module.exports = __webpack_public_path__ + "media/wario.ceb51b33.wav";